<script setup>
    import Layout from "@/layouts/main.vue";
    import PageHeader from "@/components/page-header";  
    import useVuelidate from "@vuelidate/core";
    import { required, helpers } from "@vuelidate/validators";
    import { computed, ref, reactive } from 'vue';
    import { useStore } from 'vuex';

    const state = reactive({
        title: '',
        description: '',
    });

    const rules = computed(() => ({
        title: {
            required: helpers.withMessage("Announcement title is required", required)
        },
        description: {
            required: helpers.withMessage("Announcement description is required", required),
        },
    }));

    const store = useStore();
    const v$ = useVuelidate(rules, state);
    const loading = computed(() => store.state.globals.loading);

    const title = ref("Announcement");
    const items = ref([
        {
            text: "Home",
            href: "/",
        },
        {
            text: "Announcement",
            href: "/announcement/list",
            active: true
        },
        {
            text: "Add New Announcement",
            active: true,
        }
    ]);

    const submitted = ref(false);
    const notification = computed(() => store.state.notification);

    const createAnnouncement = () => {
        submitted.value = true
        v$.value.$touch();

        if (v$.value.$invalid) return;
        store.dispatch('announcement/createAnnouncement', state);
    }
</script>

<template>
  <Layout>
    <PageHeader back="/announcement/list" :title="title" :items="items" />
    <div class="row">
        <div class="col lg-12">
            <b-overlay :show="loading">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Add New Announcement</h4>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="createAnnouncement" class="mx-2">
                            <div v-if="notification.messages.length > 0">
                                <b-alert v-for="(message, index) in notification.messages" :key="index"
                                    show variant="danger" class="fade show" role="alert">
                                    {{ message }}
                                </b-alert>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label for="title" class="form-label required">Announcement Title</label> 
                                        <input
                                            autofocus
                                            :class="{ 'is-invalid': submitted && v$.title.$error }"
                                            v-model="state.title" type="text" class="form-control" placeholder="Enter announcement title..." id="title" />
                                        <div
                                            v-for="item of v$.title.$errors"
                                            :key="item.$uid"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="item.$message">{{ item.$message }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label for="description" class="form-label">Announcement Description</label> 
                                        <textarea v-model="state.description" class="form-control" placeholder="Enter announcement description..." id="description"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="text-end">
                                        <router-link to="/announcement/list" type="submit" class="btn btn-danger mr-3">
                                            <i class="ri-close-fill fs-4 mr-1 valign-middle"></i>
                                            Cancel
                                        </router-link>
                                        <button type="submit" class="btn btn-success">
                                            <i class="ri-save-2-fill fs-4 mr-1 valign-middle"></i>
                                            Add Announcement
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
  </Layout>
</template>